import { h } from "preact";
import Router, { RoutableProps } from "preact-router";
import { baseUrl, route } from "../../App";
import { LunaEMGEStopLOT } from "./luna-emg-estop-lot";
import { LunaEMGOrder } from "./luna-emg-order";
import { LunaEMGReprint } from "./luna-emg-reprint";
import { LunaEMGSerialNumber } from "./luna-emg-serial-number";
import { LunaEMGTablet } from "./luna-emg-tablet";
import "./styles.scss";

function LunaEMGHome(props: RoutableProps) {
    return <div class="luna-emg-page">
        <h1 style="text-align: center; font-size: 30px; margin-top: 10px;">Wybierz akcje</h1>
        <div class="paper action-list">
            <div class="product-list" style="margin-top: 10px;">
                <div class="action-button" onClick={() => route("/luna-emg/serial-number")}>
                    <span class="icon">confirmation_number</span>
                    <div class="action">Wygeneruj numery seryjne</div>
                    <span class="icon">chevron_right</span>
                </div>
                <div class="action-button" onClick={() => route("/luna-emg/reprint")}>
                    <span class="icon">view_agenda</span>
                    <div class="action">Wydrukuj naklejkę dla istniejącego numeru</div>
                    <span class="icon">chevron_right</span>
                </div>
                <div class="action-button" onClick={() => route("/luna-emg/tablet")}>
                    <span class="icon">tablet_mac</span>
                    <div class="action">Zarejestruj tablet</div>
                    <span class="icon">chevron_right</span>
                </div>
                {/* <div class="action-button" onClick={() => route("/luna-emg/estop-lot")}>
                    <span class="icon">settings_remote</span>
                    <div class="action">Wprowadź nową partię pilotów</div>
                    <span class="icon">chevron_right</span>
                </div> */}
                <div class="action-button" onClick={() => route("/batch-lot-register")}>
                    <span class="icon">
                        <svg width="50" height="50">
                            <rect x="11" y="15" width="28" height="20" rx="3" style="stroke: #efefef; stroke-width: 3px; fill: none"></rect>
                            <text x="25" y="30" style="font-family: Arial; font-size: 11px; font-weight: bold; fill: white; text-anchor: middle;">LOT</text>
                        </svg>
                    </span>
                    <div class="action">Wprowadź nową partię</div>
                    <span class="icon">chevron_right</span>
                </div>
                <div class="action-button" onClick={() => route("/luna-emg/order")}>
                    <span class="icon">post_add</span>
                    <div class="action">Stwórz zestawienie</div>
                    <span class="icon">chevron_right</span>
                </div>
                <div class="action-button" onClick={() => route("/order")}>
                    <span class="icon">list_alt</span>
                    <div class="action">Pokaż zestawienia</div>
                    <span class="icon">chevron_right</span>
                </div>
            </div>
        </div>
    </div>;
}


export function LunaEMG(props: RoutableProps) {
    return <Router>
        <LunaEMGHome path={`${baseUrl}/luna-emg`}/>
        <LunaEMGSerialNumber path={`${baseUrl}/luna-emg/serial-number`}/>
        <LunaEMGReprint path={`${baseUrl}/luna-emg/reprint`}/>
        <LunaEMGTablet path={`${baseUrl}/luna-emg/tablet`}/>
        <LunaEMGEStopLOT path={`${baseUrl}/luna-emg/estop-lot`}/>
        <LunaEMGOrder path={`${baseUrl}/luna-emg/order/:id?`}/>
    </Router>
}
